import React, { useCallback, useState, useMemo, useEffect } from "react";
import Table from "../../../../../../../common/element/Table";
import Button from "../../../../../../../common/element/Buttons";
import { useLocation, useNavigate } from "react-router-dom";
import { debounce } from "../../../../../../../common/snippet/Debouncing";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import AddEditEmployee from "./AddEditEmployee";
import ImportCSV from "./ImportCsv";
import DeleteModal from "../../../../../../../common/Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../../../../../../../redux/auth/authSelector";
import { ROLES } from "../../../../../../../config/rolePermissions";
import {
  addEmployee,
  updateEmployee,
  getEmployeesList,
  importEmployeesCsv,
  deleteEmployee,
  clearAddEmployee,
  clearUpdateEmployee,
  clearImportEmployeesCsv,
  clearDeleteEmployee,
} from "../../../../../../../redux/Employee/employeesSlice";
import {
  selectAddEmployeeData,
  selectAddEmployeeError,
  selectAddEmployeeLoading,
  selectUpdateEmployeeData,
  selectUpdateEmployeeError,
  selectUpdateEmployeeLoading,
  selectEmployeesList,
  selectEmployeesListLoading,
  selectEmployeesListTotal,
  selectImportEmployeesCsvData,
  selectImportEmployeesCsvError,
  selectImportEmployeesCsvLoading,
  selectDeleteEmployeeData,
  selectDeleteEmployeeError,
  selectDeleteEmployeeLoading,
} from "../../../../../../../redux/Employee/employeesSelector";
import SweetAlertService from "../../../../../../../common/SweetAlert/SweetAlert";
import ThreeDotLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import moment from "moment";
import { Pagination } from "../../../../../../../common/pagination";
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";
import CommonIconButton from "../../../../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const EmployeesTab = ({ companydata }) => {
  const dispatch = useDispatch();

  // State
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(10);
  const [importCsvDialogOpen, setImportCsvDialogOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [allEmployeesData, setAllEmployeesData] = useState([]);
  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Selectors
  const userData = useSelector(selectUserData);
  const isAdmin = userData?.role_name === ROLES.ADMIN;
  const isActiveCompany = companydata?.hasOwnProperty('company_isActive') ? companydata?.company_isActive : userData?.company_isActive;

  const employees = useSelector(selectEmployeesList);
  const employeesTotal = useSelector(selectEmployeesListTotal);
  const employeesLoading = useSelector(selectEmployeesListLoading);

  const addEmployeeData = useSelector(selectAddEmployeeData);
  const addEmployeeError = useSelector(selectAddEmployeeError);
  const addEmployeeLoading = useSelector(selectAddEmployeeLoading);

  const updateEmployeeData = useSelector(selectUpdateEmployeeData);
  const updateEmployeeError = useSelector(selectUpdateEmployeeError);
  const updateEmployeeLoading = useSelector(selectUpdateEmployeeLoading);

  const importCsvData = useSelector(selectImportEmployeesCsvData);
  const importCsvError = useSelector(selectImportEmployeesCsvError);
  const importCsvLoading = useSelector(selectImportEmployeesCsvLoading);

  const deleteEmployeeData = useSelector(selectDeleteEmployeeData);
  const deleteEmployeeError = useSelector(selectDeleteEmployeeError);
  const isDeleting = useSelector(selectDeleteEmployeeLoading);

  const currentPageCount = employees?.length || 0;
  // Navigation
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get('tab');
  const routeCompanyId = searchParams.get('companyId');
  const effectiveCompanyId = routeCompanyId;

  // Utility Functions
  const getName = useCallback((item) => {
    const user = item?.user || {};
    const composed = [user.first_name, user.last_name].filter(Boolean).join(" ");
    return item.employeeName || item.name || composed || "N/A";
  }, []);

  const getEmail = useCallback((item) => {
    const user = item?.user || {};
    return item.emailAddress || item.email || user.email || "N/A";
  }, []);

  const getPhone = useCallback((item) => {
    const user = item?.user || {};
    return item.mobileNumber || item.phoneNumber || item.phone || user.mobile_number || "N/A";
  }, []);



  // Handlers
  const handleSearch = (e) => {
    const value = e.target.value.trim();
    SetFilterData((prev) => ({ ...prev, search: value }));
  };

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setIsEditMode(false);
    setSelectedEmployee(null);
  };

  const handlePageChange = (page) => {
    setfilterpage(page);

  };


  const handleAddEditSubmit = (payload) => {
    if (isEditMode && selectedEmployee) {
      const employeeId = selectedEmployee?.company_employee_id || selectedEmployee?.employee_id || selectedEmployee?.id || selectedEmployee?._id;
      dispatch(updateEmployee({ companyId: effectiveCompanyId, employeeId, data: payload }));
    } else {
      dispatch(addEmployee({ companyId: effectiveCompanyId, data: payload }));
    }
  };

  const handleImportCsvSubmit = (formDataObj) => {
    dispatch(importEmployeesCsv({ companyId: effectiveCompanyId, formData: formDataObj }));
  };

  const handleOpenAdd = () => {
    setSelectedEmployee(null);
    setIsEditMode(false);
    setIsDialogOpen(true);
  };

  const handleOpenEdit = (item) => {
    setSelectedEmployee(item);
    setIsEditMode(true);
    setIsDialogOpen(true);
  };

  const handleDelete = async () => {
    if (!employeeToDelete) return;

    // Extract employee ID from multiple possible property names
    const employeeId =
      employeeToDelete?.company_employee_id ||
      employeeToDelete?.employee_id ||
      employeeToDelete?.id ||
      employeeToDelete?._id;

    console.log("Delete payload:", {
      company_id: effectiveCompanyId,
      employee_id: employeeId,
      employeeObject: employeeToDelete
    });

    // Validate before making the API call
    if (!effectiveCompanyId) {
      SweetAlertService.showError({
        title: "Error",
        message: "Company ID is missing",
      });
      return;
    }

    if (!employeeId) {
      SweetAlertService.showError({
        title: "Error",
        message: "Employee ID is missing",
      });
      return;
    }

    try {
      // Dispatch the delete action
      await dispatch(deleteEmployee({
        company_id: parseInt(effectiveCompanyId),
        employee_id: employeeId
      })).unwrap();

      // Success handling
      SweetAlertService.showSuccess({
        title: "Deleted",
        message: "Employee deleted successfully",
      });

      // Close modal and clear state
      setIsDeleteModalOpen(false);
      setEmployeeToDelete(null);

      // Clear delete state and refresh the list
      dispatch(clearDeleteEmployee());
      fetchEmployees();

    } catch (error) {
      // Error handling
      SweetAlertService.showError({
        title: "Error",
        message: error || "Failed to delete employee",
      });
      setIsDeleteModalOpen(false);
      setEmployeeToDelete(null);
    }
  };

  const handleDeleteConfirm = () => {
    handleDelete();
  };

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setEmployeeToDelete(null);
  };

  // Filtered Data
  const { page, limit, search, sort, order } = getFilterData;

  const filteredData = useMemo(() => {
    if (!getFilterData.search) return allEmployeesData;
    const searchValue = getFilterData.search.toLowerCase();

    return allEmployeesData.filter(
      (item) =>
        getName(item).toLowerCase().includes(searchValue) ||
        getEmail(item).toLowerCase().includes(searchValue) ||
        getPhone(item).toLowerCase().includes(searchValue)

    );
  }, [getFilterData.search, allEmployeesData, getName, getEmail, getPhone]);

  // Fetch Employees
  const fetchEmployees = useCallback(() => {
    if (!effectiveCompanyId) return;
    dispatch(
      getEmployeesList({
        companyId: effectiveCompanyId,
        page: filterpage,
        limit: filterlimit,
        search,
        sort,
        order,
      })
    );
  }, [dispatch, effectiveCompanyId, filterpage, filterlimit, search, sort, order]);

  // Effects
  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  useEffect(() => {
    setAllEmployeesData(employees || []);
    const total = employeesTotal;
    console.log(total, "totaltotaltotal")
    setCountData(total);
    setTotalPages(Math.max(1, Math.ceil(total / (filterlimit || 10))));
  }, [employees, employeesTotal, filterlimit]);

  // Add Employee Effects
  useEffect(() => {
    if (addEmployeeData) {
      SweetAlertService.showSuccess({
        title: "Success",
        message: addEmployeeData?.message || "Employee added successfully.",
      });
      handleDialogClose();
      dispatch(clearAddEmployee());
      fetchEmployees();
    }
  }, [addEmployeeData, dispatch, fetchEmployees]);

  useEffect(() => {
    if (addEmployeeError) {
      SweetAlertService.showError({
        title: "Error",
        message: addEmployeeError || "Failed to add employee.",
      });
      dispatch(clearAddEmployee());
    }
  }, [addEmployeeError, dispatch]);

  // Update Employee Effects
  useEffect(() => {
    if (updateEmployeeData) {
      SweetAlertService.showSuccess({
        title: "Updated",
        message: updateEmployeeData?.message || "Employee updated successfully.",
      });
      handleDialogClose();
      dispatch(clearUpdateEmployee());
      fetchEmployees();
    }
  }, [updateEmployeeData, dispatch, fetchEmployees]);

  useEffect(() => {
    if (updateEmployeeError) {
      SweetAlertService.showError({
        title: "Error",
        message: updateEmployeeError || "Failed to update employee.",
      });
      dispatch(clearUpdateEmployee());
    }
  }, [updateEmployeeError, dispatch]);

  // Import CSV Effects
  useEffect(() => {
    if (importCsvData) {
      SweetAlertService.showSuccess({
        title: "Imported",
        message: importCsvData?.message || "Employees imported successfully.",
      });
      setImportCsvDialogOpen(false);
      dispatch(clearImportEmployeesCsv());
      fetchEmployees();
    }
  }, [importCsvData, dispatch, fetchEmployees]);

  useEffect(() => {
    if (importCsvError) {
      SweetAlertService.showError({
        title: "Error",
        message: importCsvError || "Failed to import employees.",
      });
      dispatch(clearImportEmployeesCsv());
    }
  }, [importCsvError, dispatch]);

  // Delete Employee Effects
  useEffect(() => {
    if (deleteEmployeeData) {
      SweetAlertService.showSuccess({
        title: "Deleted",
        message: deleteEmployeeData?.message || "Employee deleted successfully.",
      });
      setIsDeleteModalOpen(false);
      setEmployeeToDelete(null);
      dispatch(clearDeleteEmployee());
      fetchEmployees();
    }
  }, [deleteEmployeeData, dispatch, fetchEmployees]);

  useEffect(() => {
    if (deleteEmployeeError) {
      SweetAlertService.showError({
        title: "Error",
        message: deleteEmployeeError || "Failed to delete employee.",
      });
      dispatch(clearDeleteEmployee());
    }
  }, [deleteEmployeeError, dispatch]);

  return (
    <>
      <ToolManagmentCard>
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-start font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">Employees</h4>

          {(isAdmin && companydata?.company_isActive) && (
            <div className="flex items-center gap-3">
              <a href="/employees_format.csv" download="employees_format.csv"> <Button
                variant="primary"

                className="border border-[#FF8E1C] flex items-center justify-center rounded-lg h-9 bg-[#FF8E1C] text-white text-sm font-semibold hover:bg-[#e57d12] focus:bg-[#FF8E1C] duration-100 gap-1 px-5"
              >
                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.8 6.08125C16.9281 5.74688 17 5.38125 17 5C17 3.34375 15.6562 2 14 2C13.3844 2 12.8094 2.1875 12.3344 2.50625C11.4688 1.00625 9.85312 0 8 0C5.2375 0 3 2.2375 3 5C3 5.08437 3.00312 5.16875 3.00625 5.25313C1.25625 5.86875 0 7.5375 0 9.5C0 11.9844 2.01562 14 4.5 14H16C18.2094 14 20 12.2094 20 10C20 8.06563 18.625 6.45 16.8 6.08125ZM12.6469 8.85312L9.35312 12.1469C9.15937 12.3406 8.84063 12.3406 8.64688 12.1469L5.35313 8.85312C5.0375 8.5375 5.2625 8 5.70625 8H7.75V4.5C7.75 4.225 7.975 4 8.25 4H9.75C10.025 4 10.25 4.225 10.25 4.5V8H12.2937C12.7375 8 12.9625 8.5375 12.6469 8.85312Z" fill="white" />
                </svg>

              </Button>
              </a>

              <Button
                variant="primary"
                onClick={() => setImportCsvDialogOpen(true)}
                className="border border-[#FF8E1C] flex items-center justify-center rounded-lg h-9 bg-[#FF8E1C] text-white text-sm font-semibold hover:bg-[#e57d12] focus:bg-[#FF8E1C] duration-100 gap-1 px-5"
              >
                Import CSV
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66732 0.833984V12.5007M0.833984 6.66732H12.5007"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Button>

              <Button
                onClick={handleOpenAdd}
                variant="primary"
                className="border border-[#FF8E1C] flex items-center justify-center rounded-lg h-9 bg-[#FF8E1C] text-white text-sm font-semibold hover:bg-[#e57d12] focus:bg-[#FF8E1C] duration-100 gap-1 px-5"
              >
                Add Employee
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66732 0.833984V12.5007M0.833984 6.66732H12.5007"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Button>
            </div>
          )}
        </div>

        <div className="gap-y-4 border-t border-gray-200 py-2"></div>
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden ">
          <Table className="w-full text-sm text-gray-700">
            <THead>
              <Tr className="bg-[#F9F9FB] ">
                <Th >S No.</Th>
                <Th >Employee Name</Th>
                <Th >Email Address</Th>
                <Th >Mobile Number</Th>
                <Th >Batch</Th>
                <Th >Last Session Date</Th>
                <Th >Action</Th>
              </Tr>
            </THead>

            <TBody>
              {employeesLoading ? (
                <Tr>
                  <Td colSpan={7} className="text-center text-gray-500 py-6 text-sm">
                    <ThreeDotBouncingLoader />
                  </Td>
                </Tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <Tr
                    key={item.id || index}
                    className="border-t border-gray-100 hover:bg-gray-50 transition-colors text-start"
                  >
                    <Td className="py-3 px-4">
                      {String((filterpage - 1) * filterlimit + index + 1).padStart(2, "0")}
                    </Td>
                    <Td className="">{getName(item)}</Td>
                    <Td className="">{getEmail(item)}</Td>
                    <Td className="">{getPhone(item)}</Td>
                    <Td className=""> {item?.batch?.batch_name || "—"} </Td>
                    <Td >
                      {item.lastSessionDate || item.last_session_date
                        ? moment(item.lastSessionDate || item.last_session_date).format("LLL")
                        : "—"}
                    </Td>
                    <Td className=" ">
                      <div className="flex gap-1">
                        <CommonIconButton
                          type="view"
                          onClick={() =>
                            navigate(`?companyId=${effectiveCompanyId || item.company_id || item.companyId}&tab=${tab}&employeeId=${item.company_employee_id || item.employee_id || item.id}`)
                          }
                        />
                        {/* Edit Button - Only for Admin */}
                        {(isAdmin && companydata?.company_isActive) && (
                          <CommonIconButton
                          type="edit"
                            onClick={() => {
                              handleOpenEdit(item);
                            }}
                          />
                           
                        )}

                        {/* Delete Button - Only for Admin */}
                        {(isAdmin && companydata?.company_isActive) && (
                          <CommonIconButton
                            type="delete"
                            onClick={() => {
                              setEmployeeToDelete(item);
                              setIsDeleteModalOpen(true);
                            }}
                            disabled={isDeleting}
                          />
                           
                        )}
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={7}
                    className="text-center text-gray-500 py-6 text-sm"
                  >
                    No matching records found
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
        </div>

        {/* Pagination removed to match Companies list page (no pagers) */}
        <div className="flex justify-between items-center mt-3">
          {/* Left side - Pagination info */}
          <Pagination
            totalCount={countData}
            pageNumber={filterpage}
            displayPage={currentPageCount}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />

          {/* Right side - Modern Pagination Controls */}
          {countData > 0 && totalPages > 1 && (
            <ModernPagination
              totalPages={totalPages}
              currentPage={filterpage}
              onPageChange={handlePageChange}
            />
          )}
        </div>
        <AddEditEmployee
          dialogOpen={isDialogOpen}
          onDialogClose={handleDialogClose}
          employeeData={selectedEmployee}
          isEdit={isEditMode}
          onSubmit={handleAddEditSubmit}
          loading={isEditMode ? updateEmployeeLoading : addEmployeeLoading}
        />

        <ImportCSV
          dialogOpen={importCsvDialogOpen}
          onDialogClose={() => setImportCsvDialogOpen(false)}
          onSubmit={handleImportCsvSubmit}
          loading={importCsvLoading}
          fetchEmployees={fetchEmployees}
          routeCompanyId={routeCompanyId}
        />

        <DeleteModal
          dialogOpen={isDeleteModalOpen}
          onDialogClose={handleDeleteModalClose}
          onConfirm={handleDeleteConfirm}
          loading={isDeleting}
        />
      </ToolManagmentCard>
    </>
  );
};

export default EmployeesTab;